import { f7 } from 'framework7-react';
import { FC } from 'react';
import style from './bannerListStyle.module.css';
import { isApp } from '@/config/device';
import { Banner } from '@/types/api/bannerApi';

interface BannerListProps {
  banners?: Banner[];
}
export const BannerList: FC<BannerListProps> = ({ banners }) => {
  const handleClickBanner = (path_type: number, path: string) => {
    if (path_type === 1) {
      f7.views.main.router.navigate(path);
    } else if (path_type === 2) {
      if (isApp) {
        window.open(path + 'path_type=2', '_blank');
        return;
      }
      window.open(path, '_blank');
    }
  };

  return (
    <div className={style['banner-list']}>
      {banners?.map(({ path_type, url, image_file_path, title, detail_text }, index) => (
        <div
          className={style['banner-card']}
          key={index}
          onClick={() => path_type && url && handleClickBanner(path_type, url)}
        >
          <div className={style['banner-image']}>
            <img src={image_file_path} alt={title || ''} />
          </div>
          <div className={style['banner-text']}>
            {title && <div className={style['banner-title']}>{title}</div>}
            {detail_text && <div className={style['banner-detail']}>{detail_text}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};
